import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';

function LinkedinFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    d: "M17 8c-2.115 0-3.867 1.25-4.71 2.156-.098.106-.29.038-.29-.106v-1.3a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v11.5c0 .414.336.75.75.75h2.5a.75.75 0 00.75-.75v-5.812c0-1.5 1-3.438 3.267-3.438 2 0 2.733 1.624 2.733 3v6.25c0 .414.336.75.75.75h2.5a.75.75 0 00.75-.75V13.5C22 10 20 8 17 8z"
  }), React.createElement(Rect, {
    width: 4,
    height: 4,
    x: 2,
    y: 2,
    rx: 1
  }), React.createElement(Rect, {
    width: 4,
    height: 13,
    x: 2,
    y: 8,
    rx: 0.75
  }));
}

export default LinkedinFill;